import { Datatable } from './Datatable';
import { initM2MClientAccessTable } from './js/portal/manageM2MApiAccess';

const tableId = 'table-manage-m2m-portal-api-access';

export default function ManageM2MPortalAPIAccessPage() {
  const page = (
    <>
      <div id="manage4WheelsClusterOptionsInfo" class="row">
        <div class="col-lg-12">
          <div class="card form-card">
            <div class="card-header">Create, Update or Revoke Portal API Access for Machine-to-Machine Clients</div>
            <div class="card-body">
              <div class="tab-content">
                <div class="tab">
                  <div class="infobox card card-body">
                    <p>
                      On this page you can create, revoke or update Portal API access for one or more of your M2M
                      clients.
                    </p>
                    <p>
                      The M2M client id should have been issued by{' '}
                      <a href="https://bmwprod.service-now.com/webeam_next?id=wen_home" target="_blank">
                        <b>WebEAM</b>
                      </a>{' '}
                      and registered in <b>Apigee</b> via the{' '}
                      <a href="https://api.gcp.bmw.cloud/apim/portal" target="_blank">
                        APIM portal
                      </a>{' '}
                      before it can be used to access the <b>Self-Service Portal API</b>.
                    </p>
                    <p>
                      <strong>IMPORTANT NOTES:</strong>
                      <ul>
                        <li>
                          The M2M access is only usable for platform use cases such as cdh, scp or connecteddrive. Non
                          valid use cases will be rejected.
                        </li>
                        <li>M2M access via Apigee to the Self-Service Portal API has to be approved by FG-842.</li>
                        <li>
                          To access the Self-Service Portal API, you need to use the URL https://api.bmw.com/fpc/aws/v1
                          or https://api.bmw.com/fpc/aws-cn/v1 for accessing the API in China.
                        </li>
                        <li>
                          You can only view, update or revoke the portal API accesses for clients in your
                          responsibility.
                        </li>
                        <li>
                          When you request Portal API access for your M2M client, your name will automatically be added
                          as part of the responsibles list.
                        </li>
                        <li>
                          An M2M client can only be mapped to a portal service user. The users that you see in the
                          dropdown input field in the request form are all service (non-human) users.
                        </li>
                        <li>
                          You can select 1 or more users from the dropdown of the "Responsibles" field in the request
                          form.
                        </li>
                      </ul>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row row-cols-auto justify-content-end gy-3 mb-4">
        <div id="list-all-m2m-access-info-div" class="col col-auto align-self-center d-none">
          <div class="form-check form-switch">
            <input class="form-check-input danger" type="checkbox" id="list-all-m2m-access-info-switch" />
            <label class="form-check-label" for="list-all-m2m-access-info-switch">
              List All M2M Access Info
            </label>
          </div>
        </div>
      </div>

      <Datatable tableId={tableId} />
    </>
  );

  async function onPageReady() {
    initM2MClientAccessTable(tableId);
  }

  return [page, onPageReady];
}
